import React from 'react';
import chevronRight from '../../logos/chevron-right.svg';
import './Button.scss';
import classNames from 'classnames';

const Button = ({ handleClick, label, isDisabled, isLoading }) => {
  return (
    <button
      onClick={handleClick}
      className={classNames('tmx-buttons', {
        'tmx-buttons--disabled': isDisabled || isLoading
      })}
      disabled={isDisabled || isLoading}>
      {isLoading && <span className="loader"></span>}
      {label ? <div className="tmx-input__buttonLabel">{label}</div> : null}
      <img src={chevronRight} alt="chevron-right" />
    </button>
  );
};

export default Button;
